import Button from "@ingka/button";
import Modal, { Prompt, ModalFooter, ModalHeader } from "@ingka/modal";
import React, { useState } from "react";

const ErrorDialog = ({ errorTitle, errorDescription, buttonText, ...props }) => {
	const [modalOpen, setModalOpen] = useState(true);
	const { setShowValidationError } = props;

	return (
		<Modal
			visible={modalOpen}
			focusLockProps={focus}
			handleCloseBtn={() => {
				if (setShowValidationError) {
					setShowValidationError(false);
				}
				setModalOpen(false);
			}}
		>
			<Prompt
				title={errorTitle}
				header={<ModalHeader />}
				footer={
					<ModalFooter>
						<Button
							text={buttonText}
							type="primary"
							onClick={() => {
								if (setShowValidationError) {
									setShowValidationError(false);
								}
								setModalOpen(false);
							}}
						/>
					</ModalFooter>
				}
			>
				<p>{errorDescription}</p>
			</Prompt>
		</Modal>
	);
};
const focus = {
	returnFocus: false,
	autoFocus: false
};
export default ErrorDialog;

